import { SetupPage, TabPermission } from 'src/app/core/interfaces/permissions';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';
import { BrandSettings } from '../../../brand-settings.setup';

const parent: SetupPage = BrandSettings.pages.general;
const path = 'bill-on-bill-to';
const title = 'GLOBAL_TERMS.BILL_ON_BILL_TO.TITLE';
const res = ['actions', 'actions.editBillOnBillTo'];
export const BrandSettingsGeneralBillOnBillToTab: TabPermission =
  PermissionsC.generateTabPermission(parent, path, title, res);
